import { Injectable } from '@angular/core';
import { Milestone, MilestoneStage } from '@models';

@Injectable({
  providedIn: 'root'
})
export class CommonFunctionsService {
  formatDate(date: string | null): string {
    if (!date) return '--';
    const safeDate = date?.replace(' ', 'T');
    const dateObj = new Date(safeDate);
    if (isNaN(dateObj.getTime())) return '--';

    return this.getFormattedDate(dateObj);
  }

  formatUndefinedDate(date: string | null): string | undefined {
    if (!date) return;
    const safeDate = date?.replace(' ', 'T');
    const dateObj = new Date(safeDate);

    if (isNaN(dateObj.getTime())) return;

    return this.getFormattedDate(dateObj);
  }

  formatNumberWithCommas(value: number): string {
    return value.toLocaleString();
  }

  roundValue(value: number, roundingDigits: number): number {
    return parseFloat(value.toFixed(roundingDigits));
  }

  private getFormattedDate(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const monthAbbr = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();

    return `${day}-${monthAbbr}-${year}`;
  }

  getBrowserTimezone(): string {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }

  getMilestonesFlatMapFromStages(stages: MilestoneStage[]): Milestone[] {
    return stages.flatMap((stage) =>
      stage.milestones.flatMap((item) => (item.type === 'group' ? item.milestones : [item]))
    );
  }

  toSentenceCase(text: string | undefined): string {
    if (!text || text === '') return '';
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  }
}
